<template>
  <div style="width: 100%">
    <v-text-field
      :label="label"
      v-on="$listeners"
      v-bind="[defaultProps, $attrs]"
      :clearable="clearable"
      persistent-placeholder
      :counter="counter"
    >
      <template #label>
        <slot name="label"
          >{{ label }}<span v-show="required" class="red--text"> *</span></slot
        >
      </template>
      <template #append>
        <slot name="append"></slot>
      </template>
      <template #append-outer>
        <slot name="append-outer"></slot>
      </template>
      <template #prepend>
        <slot name="prepend"></slot>
      </template>
      <template #prepend-inner>
        <slot name="prepend-inner"></slot>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import { defaultPropsInput } from "@/mixins/defaultPropsInput";

export default {
  name: "BaseTextField",
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    counter: {
      type: [Boolean, String],
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [defaultPropsInput],
};
</script>

<style>
.input-labels {
  align-self: flex-start;
  font-size: 0.875rem !important;
  margin-bottom: 0.375rem;
}
.info-label {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
}

.v-window__container {
  width: 100% !important;
}
</style>
